<template>
  <BaseVeeForm :action="handleFormSubmit">
    <template #default="formProps">
      <VModal ref="dialog" :disable-backdrop-click="formProps.isPending" @close="$emit('close')">
        <template #default="modalProps">
          <div class="rounded shadow-xs w-full max-w-lg mx-auto">
            <div class="rounded shadow-lg bg-white">
              <div class="px-4 sm:px-6 py-5 border-b">
                <div class="flex items-center justify-between">
                  <div class="flex-1">
                    <h1 class="text-sm">Transfer ownership</h1>
                  </div>

                  <div class="flex-none">
                    <button
                      type="button"
                      class="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      @click="modalProps.close"
                    >
                      <span class="sr-only">Close</span>
                      <svg
                        class="inline-flex h-6 w-6"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <div class="p-4 sm:p-6 space-y-8">
                <div class="space-y-6">
                  <p>
                    You are about to transfer ownership of this account to <b>{{ memberName }}</b
                    >. Are you sure?
                  </p>
                  <BaseFormTextFieldWithValidator
                    :value="formData.membership_id"
                    v-bind="membershipFieldProps"
                  />
                </div>

                <div class="flex gap-3 justify-end">
                  <BaseButton primary> Yes, transfer </BaseButton>
                  <BaseButton type="button" ghost @click="modalProps.close()"> Cancel </BaseButton>
                </div>
              </div>
            </div>
          </div>
        </template>
      </VModal>
    </template>
  </BaseVeeForm>
</template>

<script>
import { accountOwnerClient } from '@/api/clients';

export default {
  props: {
    membership: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        membership_id: this.membership.id,
      },
    };
  },
  computed: {
    memberName() {
      return this.membership?.user?.fullName || 'Unknown';
    },
    membershipFieldProps() {
      return {
        validator: {
          name: 'membership',
          vid: 'membership_id',
          rules: { required: true },
        },
        field: {
          id: 'membership',
          inputType: 'hidden',
        },
      };
    },
  },
  methods: {
    handleFormSubmit() {
      return accountOwnerClient.update(this.membership.account_id, this.formData).then(() => {
        this.$emit('success');
        this.$refs.dialog?.close();
      });
    },
  },
};
</script>
